import * as React from 'react'

import BaseTextField, { defaultTextFieldProps } from './BaseTextField'
import { ITextFieldProps } from './types'

interface IProps extends ITextFieldProps {
  onChange: (value: string) => void
}

function TextField(props: IProps) {
  const { onChange, ...moreProps } = props

  return (
    <BaseTextField
      {...moreProps}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
    />
  )
}

TextField.defaultProps = defaultTextFieldProps

export default React.memo(TextField)
